var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"text-xs text-grey-dark my-3 leading-normal"},[_vm._v("\n  By saving this card you authorise StrataVault to store your card details\n  and automatically charge this card for your subscription fees on a\n  recurring basis, until you cancel or change your payment method.\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }